/* Keep Queen's cart indicators synchronized with Dawn's shopping events. */
(() => {
  let sequence = 0;
  function sync() {
    const request = ++sequence;
    const base = window.Shopify?.routes?.root || '/';
    fetch(base + 'cart?view=ajax', { credentials: 'same-origin' })
      .then(response => { if (!response.ok) throw new Error('Cart unavailable'); return response.text(); })
      .then(html => {
        if (request !== sequence) return;
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const data = documentFragment.querySelector('[data-queen-cart-status]');
        if (!data) return;
        const cart = JSON.parse(data.textContent);
        document.querySelectorAll('.umbrella_number').forEach(node => { node.textContent = cart.count; });
        document.querySelectorAll('.num-items-in-cart .total').forEach(node => { node.textContent = cart.total; });
        document.querySelectorAll('.pp-cart-count').forEach(node => { node.textContent = cart.count + (cart.count === 1 ? ' item' : ' items'); });
      })
      .catch(() => { /* A subsequent cart event or navigation retries the indicators. */ });
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, sync);
    }
  });
})();
